<template>
    <div class="bordas ocupacao_total">
        <h4>Taxa de Ocupação Operacional - Total</h4>
        <span>{{ocupacao_total}}%</span><br><br>

        <h4>Taxa de Ocupação Operacional - Leito Operacional</h4>
        <span>{{ocupacao_operacional}}%</span><br><br>

        <h4>Taxa de Ocupação Operacional - Leito Extra</h4>
        <span>{{ocupacao_extra}}%</span>
    </div>
</template>

<script>
export default {
    computed: {
        listagemMapaLeitos () {
            return this.$store.getters['leitos/getListagemMapaLeitos']
        },
        enfermariaSelecionada () {
            return this.$store.getters['filtro/getEnfermariaSelecionada']
        },
        ocupacao_total () {
            let info = this.listagemMapaLeitos.dados
            if (this.enfermariaSelecionada != '') info = info.filter(i => i.leitoNomeEnfermaria == this.enfermariaSelecionada)

            let listagemTotal = info.filter(i => i.leitoStatus != 2 && i.leitoHidratacao != 1).length
            let ocupados      = info.filter(i => i.leitoStatus == 1 && i.leitoHidratacao != 1)
            let porcentagem   = Math.floor(ocupados.length / listagemTotal * 100)

            if (isNaN(porcentagem)) porcentagem = 0

            return porcentagem
        },
        ocupacao_operacional () {
            let info = this.listagemMapaLeitos.dados
            if (this.enfermariaSelecionada != '') info = info.filter(i => i.leitoNomeEnfermaria == this.enfermariaSelecionada)

            let listagemTotal = info.filter(i => i.leitoExtra == 0 && i.leitoStatus != 2 && i.leitoHidratacao != 1).length
            let ocupados      = info.filter(i => i.leitoStatus == 1 && i.leitoExtra == 0 && i.leitoHidratacao != 1)
            let porcentagem   = Math.floor(ocupados.length / listagemTotal * 100)

            if (isNaN(porcentagem)) porcentagem = 0

            return porcentagem
        },
        ocupacao_extra () {
            let info = this.listagemMapaLeitos.dados
            if (this.enfermariaSelecionada != '') info = info.filter(i => i.leitoNomeEnfermaria == this.enfermariaSelecionada)

            let listagemTotal = info.filter(i => i.leitoExtra == 1 && i.leitoStatus != 2 && i.leitoHidratacao != 1).length
            let ocupados      = info.filter(i => i.leitoStatus == 1 && i.leitoExtra == 1 && i.leitoHidratacao != 1)
            let porcentagem   = Math.floor(ocupados.length / listagemTotal * 100)

            if (isNaN(porcentagem)) porcentagem = 0

            return porcentagem
        }
    }
}
</script>

<style>
    .ocupacao_total {
        display: none;
        text-align: center;
    }
    .ocupacao_total h4 {
        font-size: 1rem;
    }
    .ocupacao_total span {
        font-size: 2rem;
        color: #056f94;
    }
    
    @media (min-width: 1154px) {
        .ocupacao_total {
            display: block;
        }
    }
</style>